import { render, staticRenderFns } from "./createDiagnostico.vue?vue&type=template&id=2afc2fbe&scoped=true&"
import script from "./createDiagnostico.vue?vue&type=script&lang=js&"
export * from "./createDiagnostico.vue?vue&type=script&lang=js&"
import style0 from "./createDiagnostico.vue?vue&type=style&index=0&id=2afc2fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc2fbe",
  null
  
)

export default component.exports